import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth, db } from '../firebase/firebaseConfig';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { ref, get, set } from 'firebase/database';
import { generateId } from '../firebase/idGenerator';
import { createNotification, sendTemplateNotification } from '../services/notificationService';

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      
      // Fetch user profile from Realtime DB to check role and status
      const userRef = ref(db, `users/${user.uid}`);
      const snapshot = await get(userRef);
      
      let isAdmin = false;
      let userRole = 'user';
      let isSuspended = false;

      if (snapshot.exists()) {
        const userData = snapshot.val();
        
        // CHECK SUSPENSION STATUS
        if (userData.status === 'suspended' || userData.status === 'banned' || userData.status === 'blocked') {
          isSuspended = true;
        }

        if (userData.role === 'admin' || userData.role === 'superadmin' || userData.role === 'moderator' || userData.role === 'support') {
          isAdmin = true;
          userRole = userData.role;
        }
      }

      if (isSuspended) {
        setError(`Account Restricted. Access is limited due to security policy violations. To request a review, please submit a formal appeal including your PRIVATE SUPPORT (SUID): ${snapshot.val()?.suid || 'PENDING'}`);
        setLoading(false);
        return;
      }

      // Track Session
      const sessionId = await generateId('SID');
      await set(ref(db, `sessions/${sessionId}`), {
        sid: sessionId,
        uid: user.uid,
        role: userRole,
        loginTime: Date.now(),
        device: navigator.userAgent,
        status: "active"
      });

      // LOGIN NOTIFICATION (Template Based - 3h Expiry)
      await sendTemplateNotification(user.uid, 'WELCOME_BACK', 3);

      if (isAdmin) {
        navigate("/admin/dashboard");
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        setError("Invalid email or password.");
      } else {
        setError("Failed to log in. Please check your credentials.");
      }
      console.error(err);
    }
    setLoading(false);
  };

  return (
    <div className="container animate-up" style={{display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh'}}>
      <div className="glass-card" style={{ width: '100%', maxWidth: '450px', padding: '40px' }}>
        <h2 style={{textAlign: 'center', marginBottom: '30px', color: 'var(--brand-accent)'}}>Welcome Back</h2>
        
        {error && <div className="error-text" style={{background: 'rgba(255, 107, 107, 0.1)', padding: '10px', borderRadius: '8px', marginBottom: '20px', textAlign: 'center'}}>{error}</div>}
        
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input 
              type="email" 
              className="form-input" 
              required
              value={email}
              autoComplete="username"
              onChange={e => setEmail(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label className="form-label">Password</label>
            <input 
              type="password" 
              className="form-input" 
              required
              value={password}
              autoComplete="current-password"
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <button disabled={loading} type="submit" className="btn btn-primary" style={{width: '100%', marginTop: '15px'}}>
            {loading ? 'Logging in...' : 'Log In'}
          </button>
        </form>
        
        <div style={{marginTop: '25px', textAlign: 'center', fontSize: '0.95rem', color: 'var(--text-secondary)'}}>
          Don't have an account? <Link to="/register" style={{color: 'var(--brand-accent)'}}>Sign Up</Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
